import React from 'react';
import { ICON_EYE_OUTLINE } from '@doveit/bricks';
import { Design } from '../../../providers/api/dtos';
import CanvaCard from '../canva-card/CanvaCard';
import ExportMarketingDesignAction from '../../containers/export-marketing-design-action/ExportMarketingDesignAction';
import { goToPage } from '../../../utils/navigate/utils';

export interface CanvaDesignCardProps {
  design: Design,
}

/**
 * @deprecated use raw CanvaCard
 */
const CanvaDesignCard: React.FC<CanvaDesignCardProps> = ({
  design,
}) => (
  <CanvaCard
    title={design.title}
    date={design.updatedAt}
    dateLabel="Aggiornato il"
    type="design"
    thumbnailUrl={design.thumbnail?.url}
    primaryAction={(
      <ExportMarketingDesignAction
        design={design}
      />
    )}
    secondaryAction={{
      icon: { path: ICON_EYE_OUTLINE },
      label: 'Visualizza Design',
      onClick: () => goToPage(design.viewUrl),
    }}
  />
);
export default CanvaDesignCard;
